import React from 'react';

import SMStream from 'dash-front/components/sm/streams/SMStream2';

class EventSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {};

    state = {};

    render() {
        let {
            params: { eventId, tournamentId }
        } = this.props;

        return (
            <div>
                <h1>Yes, page</h1>
            </div>
        );
    }
}

export default EventSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventTeamFormSMB.js
 **/